import * as React from "react";
import { Box, Typography } from "@mui/material";

const HomeTitleBar: React.FC = () => {
    return (
        <Box
            sx={{
                width: "100%",
                border: "1px solid #E0E0E0",
                borderRadius: "4px",
                overflow: "hidden",
                display: "block",
                position: "relative",
            }}
        >
            <Box
                component="img"
                src="https://coreprodeuscclstg.blob.core.windows.net/public-web-assets/access-assets/images/HomePageTitleBar.jpg"
                alt="Home Page Title Bar"
                sx={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                }}
            />
            <Typography
                variant="body2"
                sx={{
                    position: "absolute",
                    bottom: 12,
                    right: 32,
                    color: "#555",
                    background: "rgba(255,255,255,0.85)",
                    px: 2,
                    borderRadius: 1,
                    fontWeight: 600,
                }}
            >
                Version 16.4.4
            </Typography>
        </Box>
    );
};

export default HomeTitleBar;
